// components/PromptBanner.jsx — Anamoria SPA
// v1.3 — 2.2b: warm capture variant + skipLabel prop (July 29, 2026)
//   Additive + default-off: `warm` adds the Hearth fill/border variant (capture
//   only; legacy stays sage-green). `skipLabel` lets capture show "Try something
//   else" while legacy keeps "Try a different prompt" (global rename pending
//   ratification). No render change for existing call sites.
//
// v1.2 — 2.2a: optional Dismiss affordance (July 29, 2026)
//   Additive + default-off: showDismiss defaults false, so every existing call
//   site (RecordPage/WritePage/PhotoPage/VideoPage/MemoryDetailPage) renders
//   byte-identically. When showDismiss is off the skip link renders exactly as
//   before (bare, no wrapper); the flex actions row appears only when a dismiss
//   control is present. New on the unified capture screen only.
//
// v1.1 — Prompt banner for capture screens (April 2, 2026)
//
// Props:
//   prompt       — { text, title, category, promptId } (required)
//   onSkip       — function|null — callback for the skip link
//   showSkip     — boolean — show the skip link (default: true)
//   skipLabel    — string — skip link text (default "Try a different prompt";
//                  capture passes "Try something else" pending global ratification)
//   onDismiss    — function|null — callback for the dismiss control (default: none)
//   showDismiss  — boolean — show the dismiss control (default: false)
//   dismissLabel — string — dismiss control text (default: "Not today"; copy pending ratification)
//   fullWidth    — boolean — edge-to-edge mode, no border-radius (default: false)
//   warm         — boolean — Hearth warm fill/border variant (default: false).
//                  Capture-only per the AD (Sophie 2026-07-29: bg #FAF7F0,
//                  border #EAE4D8). Default-off keeps legacy pages green.

import styles from './PromptBanner.module.css';

export default function PromptBanner({
  prompt,
  onSkip,
  showSkip = true,
  skipLabel = 'Try a different prompt',
  onDismiss,
  showDismiss = false,
  dismissLabel = 'Not today',
  fullWidth = false,
  warm = false,
}) {
  if (!prompt || !prompt.text) return null;

  const categoryLabel = prompt.title || prompt.category || "TODAY'S REMEMBRANCE";

  // Visible text IS the accessible name (WCAG 2.5.3 G211); no aria-label override.
  const skipBtn = showSkip && onSkip ? (
    <button className={styles.skip} onClick={onSkip}>
      {skipLabel}
    </button>
  ) : null;

  const dismissBtn = showDismiss && onDismiss ? (
    <button className={styles.dismiss} onClick={onDismiss}>
      {dismissLabel}
    </button>
  ) : null;

  return (
    <div className={`${styles.banner} ${fullWidth ? styles.bannerFull : ''} ${warm ? styles.bannerWarm : ''}`}>
      <span className={styles.category}>{categoryLabel}</span>
      <p className={styles.text}>{prompt.text}</p>
      {dismissBtn ? (
        <div className={styles.actions}>
          {skipBtn}
          {dismissBtn}
        </div>
      ) : (
        skipBtn
      )}
    </div>
  );
}
